import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Formik } from 'formik';

import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  FormLabel,
  FormControl,
  FormControlLabel,
  RadioGroup,
  CircularProgress,
  Radio
} from '@material-ui/core';
import { editAdditionalDriverAction } from '../redux/actions/settings-actions';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(1)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

function EditAdditionalDriverSetting(props) {
  const classes = useStyles();
  const { error, loading } = useSelector((state) => state.loading);

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } = props;

  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && errors[name],
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <FormControl component="fieldset">
        <FormLabel component="legend">Enable additional driver assistance</FormLabel>
        <RadioGroup aria-label="enabled" {...formikProps('enabled')}>
          <FormControlLabel value={'true'} control={<Radio />} label="Yes" />
          <FormControlLabel value={'false'} control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>

      <FormControl component="fieldset">
        <FormLabel component="legend">Allow drivers to request additional driver assistance from the app</FormLabel>
        <RadioGroup aria-label="request_from_app" {...formikProps('request_from_app')}>
          <FormControlLabel value={'true'} control={<Radio />} label="Yes" />
          <FormControlLabel value={'false'} control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
            >
              Save Changes
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

export function EditAdditionalDriverSettingComponent({
  can_request_additional_driver,
  openBackdrop,
  closeBackdrop,
  showSnackbar,
  handleClose
}) {
  const dispatch = useDispatch();

  const values = {
    enabled: String(can_request_additional_driver.enabled || false),
    request_from_app: String(can_request_additional_driver.request_from_app || false)
  };

  const submit = (data, actions) => {
    openBackdrop();
    data.enabled = data.enabled === 'true';
    data.request_from_app = data.request_from_app === 'true';

    const { resetForm } = actions;
    resetForm();
    const props = { closeBackdrop, showSnackbar, handleClose };
    dispatch(editAdditionalDriverAction(data, props));
  };

  return (
    <Formik initialValues={values} onSubmit={submit}>
      {(props) => <EditAdditionalDriverSetting {...props} />}
    </Formik>
  );
}
